import React from 'react';
import $ from 'jquery';

//elegant form validation
import TextView from '../../elegant_form_validation/Util/TextView.js';
import update from 'immutability-helper';
import { run, ruleRunner } from '../../elegant_form_validation/Validation/ruleRunner.js'
//import { required, mustMatch, minLength } from '../../elegant_form_validation/Validation/rules.js';
import { required } from '../../elegant_form_validation/Validation/rules.js';
//<-
//import { Redirect } from 'react-router-dom';

import Row from '../ui/Row';
import Col from '../ui/Col';

import RestClient from '../rest/RestClient';
import CommonHelper from '../helpers/CommonHelper';
import Entrance from './Entrance';
//import MicroEvent  from '../other/microevent';

import {Globs, KEY} from '../Globs';

const fieldValidations = [
  //ruleRunner("firstName", "First Name", required),
  //ruleRunner("emailAddress", "Email Address", required),
  ruleRunner("password1", "Password", required),
  //ruleRunner("password1", "Password", required, minLength(6)),
  //ruleRunner("password2", "Password Confirmation", mustMatch("password1", "Password"))
];


export default class ReAuthAccount extends React.Component {

  state = {
    redirectToReferrer: false,
    loginAttemptStarted:false,
    loginAttemptFailed: false,
  }

  pwd="";

  constructor(props) {
    super(props);

    //MicroEvent.mixin(ReAuthAccount);

    this.handleFieldChanged = this.handleFieldChanged.bind(this);
    this.errorFor = this.errorFor.bind(this);
    this.state = {
      showErrors:                         false,
      validationErrors:                   { },
      restError:                          null,
      secondsLeftToNewAccountRedirection: 4,

    }
  }

  componentWillMount() {
    // Run validations on initial state
    this.setState({validationErrors: run(this.state, fieldValidations)});


  }

  componentDidMount(){
    //Globs.set(KEY.TASK_REDIRECT_TO_REAUTH, false);

    $.fn.getCursorPosition = function() {
    var el = $(this).get(0);
    var pos = 0;
    var posEnd = 0;
    if('selectionStart' in el) {
        pos = el.selectionStart;
        posEnd = el.selectionEnd;
    } else if('selection' in document) {
        el.focus();
        var Sel = document.selection.createRange();
        var SelLength = document.selection.createRange().text.length;
        Sel.moveStart('character', -el.value.length);
        pos = Sel.text.length - SelLength;
        posEnd = Sel.text.length;
    }
    // return both selection start and end;
    return [pos, posEnd];
  };


  $('#password_field').keydown(function (e) {
      //var pwd = $(this).attr('data-input');
      var pwd = $('#zpass').val();

      var position = $(this).getCursorPosition();
      var deleted = '';
      var val = $(this).val();
      if (e.which == 8) {
          if (position[0] == position[1]) {
              if (position[0] == 0){
                  deleted = '';
              }else{
                  deleted = val.substr(position[0] - 1, 1);
                  pwd = CommonHelper.strCutBetweenIndexes(pwd, position[0] - 1, position[0]);
              }
          }
          else {
              deleted = val.substring(position[0], position[1]);
              pwd = CommonHelper.strCutBetweenIndexes(pwd, position[0], position[1]);
          }
      }
      else if (e.which == 46) {
          var val = $(this).val();
          if (position[0] == position[1]) {
              if (position[0] === val.length) {
                  deleted = '';
              }else {
                  deleted = val.substr(position[0], 1);
                  pwd = CommonHelper.strCutBetweenIndexes(pwd, position[0], position[0]+1);
              }
          }
          else {
              deleted = val.substring(position[0], position[1]);
              pwd = CommonHelper.strCutBetweenIndexes(pwd, position[0], position[1]);
          }
      }
    // Now you can test the deleted character(s) here
    $('#zpass').val(pwd);
  });

  }
  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }

  handleFieldChanged(field) {
    return (e) => {
      // update() is provided by React Immutability Helpers
      // https://facebook.github.io/react/docs/update.html
      let newState = update(this.state, {
        [field]: {$set: e.target.value}
      });
      newState.validationErrors = run(newState, fieldValidations);
      this.setState(newState);
    };
  }

  login = () => {

    this.setState({showErrors: true});
    if($.isEmptyObject(this.state.validationErrors) === false) return null;

    this.setState({ loginAttemptStarted: true });
    this.setState({ loginAttemptFailed: false });

    var pwd = $('#zpass').val();
    //RestClient.linkAccount(this.state.emailAddress, this.state.password1, () => {
    RestClient.reAuthCurrentAccount(pwd.trim(), () => {

      //this is to do the another entrance in order to automatically select newly added account
      Entrance.silentEnter(true);
      //<-

      this.setState({ loginAttemptStarted: false });
      this.setState({ loginAttemptFailed: false });
      this.setState({ redirectToReferrer: true });



      $('#zpass').val(null);
      var pwdField = document.getElementById("password_field");
      pwdField.value = null;

    },
    (error) => {
      //console.log('authentication error');
      this.setState({ restError: error});
      this.setState({ loginAttemptStarted: false });
      this.setState({ loginAttemptFailed: true });


      $('#zpass').val(null);
      var pwdField = document.getElementById("password_field");
      pwdField.value = null;
    })
  }

  countdownOfRedirectionToNewAccount(){
    var secondsLeft = (this.state.secondsLeftToNewAccountRedirection - 1);
    console.log('countdownOfRedirectionToNewAccount:' + secondsLeft);
    this.setState({secondsLeftToNewAccountRedirection:secondsLeft});

    if (secondsLeft === 0) {
      clearInterval(this.state.refreshIntervalId);

    }

  }



  copyPass() {

    var pwdField = document.getElementById("password_field");
    if (CommonHelper.isEmpty(pwdField)) {
      return ;
    }


    if(CommonHelper.isNotEmpty(pwdField.value) && pwdField.value!==""){
      //hidPwdField.value = pwdField.value;
    //  alert( pwdField.value.substr(-1));

              var str = pwdField.value;

              var idx = -1;
              for(var i=0; i<str.length;i++) {
                  if (str[i] !== "•") {
                    idx = i;
                    break;
                  }
              }

              //var thePwd = document.getElementById("zpass").value;
              var thePwd = $('#zpass').val();

              if (idx!=-1){
                if (thePwd==="" || CommonHelper.isEmpty(thePwd)){
                  //this.str = str;
                  thePwd = str;
                }else{
                  thePwd = CommonHelper.strInsert(thePwd, idx, str[idx]);
                }

                $('#zpass').val(thePwd);
              }

      var passwordLength = pwdField.value.length;
      pwdField.value =  "•".repeat(passwordLength);

    }

    pwdField.type = 'text';
    //document.getElementById("hidPassword").value = document.getElementById("password_field").value;

   // if (document.getElementById("password_field").value != "") {
   //        var passwordLength = document.getElementById("password_field").value.length;
   //       document.getElementById("password_field").value =  "•".repeat(passwordLength);
   //     }
   //    document.getElementById("password_field").type = 'text';
  }

  changeType() {

    var pwdField = document.getElementById("password_field");
    //var hidPwdField = document.getElementById("hidPassword");

    if (CommonHelper.isEmpty(pwdField)) {
      return ;
    }


    // pwdField.type = 'password';
    // pwdField.value = hidPwdField.value;


      // document.getElementById("passwordField").type = 'password';
      // document.getElementById("passwordField").value = document.getElementById("hidPassword").value;
  }

  _handleChangeEvent(val) {
          return val;
        }

  render() {




    //alert('render');
  //  Globs.set(KEY.TASK_REDIRECT_TO_REAUTH, false);

    //const { from } = this.props.location.state || { from: { pathname: '/' } };
    const { redirectToReferrer } = this.state;
    //console.log("from = %o",  from.toSource());
    //console.log("from = %o",  from);
    //<Redirect to={from}/>
    //<center><Row>The account was linked successfully!</Row></center>

//Entrance.accountsMissingAtLastLogin()


    if (redirectToReferrer) { //it is flag of success indeed

      // var greetingOnSuccess =
      //   Entrance.accountsMissingAtLastLogin()
      //   ?'<Row>The account was linked successfully!</Row>'
      //   :'<Row>The account was linked successfully! You can now switch to it by account selection box on top of the window.</Row>';

      // <Row>
      //   <a href="/">Click here to reload interface.</a>
      //   <span>You will be switched to new account automatically in {this.state.secondsLeftToNewAccountRedirection} second(s) </span>
      // </Row>

      return (
        <center>
        <br/>
        <div className="login-form">

        <Row>
          The Re-Authentication was completed successfully!
        </Row>

        </div>
        </center>

      )
    }


    var authMessage0 = 'Your current SoundCloud account needs re-authentication.'



    var authMessage1 = (this.state.loginAttemptStarted)
        ? (<div class="waiting">Authenticating<br/></div>):'';

    var authMessage2 = (this.state.loginAttemptFailed)
        ? (<p style={{color:'red'}}>Login attempt failed: <i>{this.state.restError.message}</i></p>):'';

      //console.log(this.state.restError.title);

    return  (
      <center>
      <br/>
      <div className="login-form">

      <Row>
      <Col>

      <p>{authMessage0}</p>
      {authMessage1}
      {authMessage2}
      </Col>
      </Row>
      <br/>


      <Row>

      <TextView id="sc_login_to_link"
          style={{width:'16em'}}
          placeholder="SC login"
          showError={this.state.showErrors}
          text={Entrance.decodedAccessToken()['login']} onFieldChanged={this.handleFieldChanged("emailAddress")}
          verticalWithError="true"
          disabled="true"
          errorText={this.errorFor("emailAddress")} />
      </Row>
      <Row>
      <TextView id="password_field"
        style={{width:'16em'}}
        placeholder="SoundCloud password"
        showError={this.state.showErrors}
        type="text"
        onKeyPress={(ev) => {
              if (ev.key === 'Enter') {
                         // Do code here
                         this.login();
                         ev.preventDefault();
                     }
             }}
        onFieldChanged={this.handleFieldChanged("password1")}
        verticalWithError="true"
        errorText={this.errorFor("password1")}
        onFocus={this.changeType()} onBlur={this.copyPass()}
        dataInput=""
       />
      </Row>


      <br/>
      <Row>
      <button type='submit' id="green" className="button" onClick={this.login}><span>Re-Auth!</span></button>
      </Row>
      </div>
      <input id="zpass" type="hidden" name="zpass"  onChange={(e) => {}} />

      </center>
     );
   }
 }
